<template>
  <div class="page-header" >
        <button class="page-header__link" @click="goBack"> <i class="el-icon-arrow-left"></i>Назад </button> | <h3 class="page-header__title">{{title}}</h3>
    </div>
</template>

<script>
export default {
    name: "pageHeader",
    props: {
        title: String,
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    },
}
</script>
    
<style lang="scss">
    .page-header{
        padding: 10px 0;
        display: grid;
        column-gap: 10px;
        align-items: center;
        grid-template-columns: max-content max-content 1fr;
    }  
    .page-header__link{
        padding: 0;
        color: $brand-clr-1;
        font-size: 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover{
            color: lighten($color: $brand-clr-1, $amount: 10%)
        }
    }
    .page-header__title{
        margin: 0;
        color: $regular-text-clr;
    }
</style>